
export default {
  name: 'call-button',
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    currentIcon() {
      return this.isOpen ? 'rz-icon-cross-bold' : 'rz-icon-phone';
    },
  },
};
